/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Jade_Happy_Wasp_HikeInputs */

const en_jade_happy_wasp_hike = /** @type {(inputs: Jade_Happy_Wasp_HikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Assign (${i?.count})`)
};

const de_jade_happy_wasp_hike = /** @type {(inputs: Jade_Happy_Wasp_HikeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zuweisen (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Assign ({count})" |
*
* @param {Jade_Happy_Wasp_HikeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const jade_happy_wasp_hike = /** @type {((inputs: Jade_Happy_Wasp_HikeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jade_Happy_Wasp_HikeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jade_happy_wasp_hike(inputs)
	return de_jade_happy_wasp_hike(inputs)
});